import { CollectionState, Filter, FiltersMap, KeyedItem } from '@wix/bex-core';

export interface NestedCollectionLevelDescriptor<T, F extends FiltersMap> {
  readonly depth: number;
  readonly parentKey: (item: T) => string | null | undefined;
  readonly createCollection: (params?: {
    readonly parent: KeyedItem<any> | null;
  }) => {
    collection: CollectionState<T, F>;
    parentFilter?: Filter<string[]>;
  };
  readonly fetchAllThreshold?: number;
}
